import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

import { getInhabitantPropertyInfo } from '../../../../../api'
import { FORMIK_EMPTY_VALUE } from '../../../../../constants/validation'
import { isStaffUser } from '../../../../../utils/user'
import { toInhabitantBuildingSelectItem } from '../../../../Building'
import { toFlatSelectItem } from '../../../../Flat'
import { toUserWithPropertyInfoSelectItem } from '../../../../User'
import {
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT,
  REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER,
} from '../../RequestEditApplicantAddressModal.constants'

export function useRequestEditApplicantAddressFormFields() {
  const { setFieldValue, values } = useFormikContext()

  const isInitialRenderRef = useRef(true)
  const hasInitialAddressRef = useRef(
    Boolean(
      values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING] ||
      values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT]
    )
  )
  const selectedOwner =
    values[REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_OWNER]

  function applyAddress(owner) {
    if (owner?.propertyInfo) {
      const {
        propertyInfo: {
          building,
          buildings_count: buildingsCount,
          flat,
          flats_count: flatsCount,
        },
      } = owner

      if (flatsCount > 0) {
        if (flatsCount === 1 && buildingsCount === 1) {
          setFieldValue(
            REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING,
            toInhabitantBuildingSelectItem(building)
          )
          setFieldValue(
            REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT,
            toFlatSelectItem(flat)
          )

          return
        }

        if (flatsCount > 1 && buildingsCount <= 1) {
          setFieldValue(
            REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING,
            toInhabitantBuildingSelectItem(building)
          )
          setFieldValue(
            REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT,
            FORMIK_EMPTY_VALUE
          )

          return
        }
      }

      if (!isStaffUser(owner)) {
        setFieldValue(
          REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_FLAT,
          FORMIK_EMPTY_VALUE
        )
        setFieldValue(
          REQUEST_EDIT_APPLICANT_ADDRESS_MODAL_FIELD_NAME_BUILDING,
          FORMIK_EMPTY_VALUE
        )
      }
    }
  }

  useEffect(() => {
    const shouldSkipInitialApply =
      isInitialRenderRef.current && hasInitialAddressRef.current

    isInitialRenderRef.current = false

    if (!shouldSkipInitialApply && selectedOwner) {
      if (!isStaffUser(selectedOwner) && !selectedOwner.propertyInfo) {
        getInhabitantPropertyInfo(selectedOwner.value)
          .then(response =>
            applyAddress(toUserWithPropertyInfoSelectItem(response.data))
          )
          .catch(console.error)
      }

      if (selectedOwner.propertyInfo) {
        applyAddress(selectedOwner)
      }
    }
  }, [applyAddress, selectedOwner])
}
